import axios from "axios";

export const _ = axios.create({
    baseURL: process.env.NODE_ENV === 'development' 
        ? '/' 
        : 'http://192.168.1.33:9026/.'
})